import { Box, Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useSearchParams, useNavigate, createSearchParams } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';

type BottomSectionRegisterPageProps = {
  buttonIsLoading: boolean;
};

export default function BottomSectionRegisterPage(props: BottomSectionRegisterPageProps) {
  const { buttonIsLoading } = props;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { watch } = useFormContext();

  const guestNameFieldState = watch('guestName');
  const guestEmailFieldState = watch('guestEmail');
  const agreement1Step1FieldState = watch('agreement1Step1');
  const agreement2Step1FieldState = watch('agreement2Step1');

  const isFieldWithInput =
    guestNameFieldState && guestEmailFieldState && agreement1Step1FieldState && agreement2Step1FieldState;

  let step = Number(searchParams.get('step')) || 1;
  let section = Number(searchParams.get('section')) || 1;
  const isStep4 = step === 4;

  const handleBackStep = () => {
    if (step === 1) return navigate('/attention');

    if (step === 4) {
      step = 3;
      section = 2;
    }

    navigate({
      pathname: '/registration',
      search: createSearchParams({
        step: step.toString(),
        section: section.toString()
      }).toString()
    });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, maxWidth: 500, py: 7 }}>
      {!isStep4 && (
        <Button sx={{ minWidth: '240px' }} onClick={handleBackStep} variant="outlined" disabled={buttonIsLoading}>
          Kembali
        </Button>
      )}
      <LoadingButton
        type="submit"
        variant="contained"
        loading={buttonIsLoading}
        sx={{ minWidth: '240px' }}
        disabled={!isFieldWithInput}
      >
        {isStep4 ? 'Kirim Aplikasi' : 'Lanjut'}
      </LoadingButton>
    </Box>
  );
}
